import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from '../../query/query-ids'
import { type TagData, createTag } from '~~/src/api/tags'
import type { GetArg } from '~~/src/types/utils'

export interface CreateTagMutateArgs { tag: Omit<GetArg<typeof createTag>[0], 'elementalTypeId'>; userId?: MaybeRef<string | null | undefined>;elementalId?: MaybeRef<string | null | undefined>}

export const useCreateTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation<Awaited<ReturnType<typeof createTag>>, Error, CreateTagMutateArgs>({
    mutationKey: ['create-tag'],
    mutationFn: async ({ tag }) => {
      return await createTag({ ...tag, elementalTypeId: 10 })
    },
    onMutate({ tag, userId, elementalId }) {
      queryClient.setQueriesData<TagData[]>({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      }, (old) => {
        if (!old)
          return old
        return [...old, tag as TagData]
      })
      if (elementalId) {
        queryClient.setQueriesData<TagData[]>({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
          exact: false,
          type: 'all',
        }, (old) => {
          if (!old)
            return old
          return [...old, tag as TagData]
        })
      }
    },
    onError: (_, { userId, elementalId }) => {
      queryClient.refetchQueries({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      })
      if (elementalId) {
        queryClient.refetchQueries({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],

          exact: false,
          type: 'all',
        })
      }
    },
    onSuccess: (result, { userId, elementalId, tag }) => {
      if (!result)
        return
      queryClient.setQueriesData<TagData[]>({
        queryKey: ['user-tags', userId],
        exact: false,
        type: 'all',
      }, (old) => {
        if (!old)
          return old
        return old.map(item => item.id === tag.id ? result : item) as TagData[]
      })
      if (elementalId) {
        queryClient.setQueriesData<TagData[]>({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
          exact: false,
          type: 'all',
        }, (old) => {
          if (!old)
            return old
          return old.map(item => item.id === tag.id ? result : item) as TagData[]
        })
      }
    },
  })
}
